module.exports = __webpack_public_path__ + "static/media/MK 22.337717db.mp3";